import type { SaleDetail } from '../../sales/domain/salesTypes';

export function isPendingMercadoPagoQrSale(detail: SaleDetail | null | undefined): boolean {
  if (!detail || detail.status === 'voided') return false;
  if (detail.paymentStatus === 'paid') return false;

  return detail.payments.some(
    (p) => p.methodId === 'mercadopago_qr' && p.status === 'pending'
  );
}
